import React, { ReactElement } from 'react';
import { PouzitiePredpis, TerminDetail } from 'tezaury-frontend-ts-axios';
import { Link } from 'idsk-react-components';
import { useNavigate } from 'react-router';
import DetailTerminuSectionHeading
  from '../DetailTerminuSectionHeading/DetailTerminuSectionHeading';
import DetailTerminuRow from '../DetailTerminuRow/DetailTerminuRow';
import DetailTerminuList from '../DetailTerminuList/DetailTerminuList';
import TerminDetailEmptyDataMessage
  from '../TerminDetailEmptyDataMessage/TerminDetailEmptyDataMessage';
import routes from '../../../routing/routes';

interface Props {
  termin: TerminDetail;
  admin?: boolean;
}

const DetailTerminuPouzitiePredpis = ({ termin, admin = false }: Props): ReactElement => {
  const navigate = useNavigate();

  const renderItemPouzitiePredpis = (item: PouzitiePredpis): ReactElement => {
    if (item.url) {
      return (
        <Link
          className="detail-terminu-button-link"
          to={`${process.env.REACT_APP_PORTAL_MAIN_URL}/ezbierky/pravne-predpisy${item.url}`}
          onClick={() => {
            window.parent.postMessage({
              type: 'iframe-to-parent-external-route',
              route: `/ezbierky/pravne-predpisy${item.url}`,
            }, '*');
          }}
        >
          {item.popis}
        </Link>
      );
    }
    return (
      <>
        {item.popis}
      </>
    );
  };

  return (
    <>
      {(admin || termin.pouzitiePredpisList.length > 0) && (
        <div className="detail-pouzitie-predpis">
          <DetailTerminuSectionHeading
            heading="Použitie v iných právnych predpisoch"
            admin={admin}
            onClick={() => navigate(routes.tezaurus.admin.termin.edit.pouzitieVPredpisoch
              .withParams(termin.tezaurus.uuid, termin.uuid))}
            terminListNotEmpty={termin.pouzitiePredpisList.length > 0}
          />

          {admin && termin.pouzitiePredpisList.length === 0 && (
          <TerminDetailEmptyDataMessage
            text="Termín nemá žiadne použitia v iných právnych predpisoch."
          />
          )}

          {termin.pouzitiePredpisList.length > 0 && (
          <DetailTerminuRow header="Použitie v iných právnych predpisoch">
            <DetailTerminuList
              list={termin.pouzitiePredpisList}
              renderItem={renderItemPouzitiePredpis}
              renderKey={(item) => item.uuid}
            />
          </DetailTerminuRow>
          )}
        </div>
      )}
    </>
  );
};

export default DetailTerminuPouzitiePredpis;
